import React, {useEffect} from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import ItemBanner from "../ItemBanner";
import bannerArticles from "../../data/bannerArticles";

const Banner = () => {
    const [showArticles, setShowArticles] = React.useState(false);
    const [articulosBanner, setArticulosBanner] = React.useState(null);

    const verArticulosSlide = () => {
        setShowArticles(!showArticles);
    }

    useEffect(() => {
        setArticulosBanner([...bannerArticles].sort(() => Math.random() - 0.5));
    }, []);

    return (
        <div className={ showArticles ? "banner banner--expanded" : "banner" }>
            <div className={ !showArticles ? "banner__info active" : "banner__info banner__slide" }>
                <div className="banner__info--image d-block d-sm-none col-md-7 col-lg-8">
                    <LazyLoadImage
                        alt="banner01"
                        src="https://www.appsaudi.com.mx/resources/images/boutique/banner/Banner_Movil.jpg"
                    />
                </div>
                <div className="banner__info--image d-none d-sm-block col-md-7 col-lg-8">
                    <LazyLoadImage
                        alt="banner01"
                        src="https://www.appsaudi.com.mx/resources/images/boutique/banner/Banner_Desktop.jpg"
                    />
                </div>
                <div className="banner__info--detail col-md-5 col-lg-4">
                    <h3>Comparte todo el estilo</h3>
                    <span>Audi en familia</span>
                    <p>Descubre toda la gama de Audi collection y complementa tu estilo de vida.</p>
                    <div className="ac-btns">
                        <button style={{ marginLeft: 0, marginRight: 0 }} className="btn btn-outline-white btn-singleline"
                             onClick={() =>
                                window.open(
                                    "https://www.appsaudi.com.mx/catalogo_audi_collection/new.html",
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            }
                        >
                            Catálogo digital
                        </button>
                        <button style={{ marginLeft: 0, marginRight: 0 }} onClick={() => verArticulosSlide()}>Ver</button>
                    </div>
                </div>
            </div>
            <div className={ showArticles ? "banner__articles active" : "banner__articles banner__slide" }>
                <button className="banner__articles--close" onClick={() => verArticulosSlide()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
                <div className="banner__articles--all">
                    <div className="d-block container_item">
                        {
                            articulosBanner !== null &&
                            <>
                                <ItemBanner 
                                    name={articulosBanner[0].name}
                                    idArticulo={articulosBanner[0].id}
                                    imagen={articulosBanner[0].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[1].name}
                                    idArticulo={articulosBanner[1].id}
                                    imagen={articulosBanner[1].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[2].name}
                                    idArticulo={articulosBanner[2].id}
                                    imagen={articulosBanner[2].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[3].name}
                                    idArticulo={articulosBanner[3].id}
                                    imagen={articulosBanner[3].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[4].name}
                                    idArticulo={articulosBanner[4].id}
                                    imagen={articulosBanner[4].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[5].name}
                                    idArticulo={articulosBanner[5].id}
                                    imagen={articulosBanner[5].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[6].name}
                                    idArticulo={articulosBanner[6].id}
                                    imagen={articulosBanner[6].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[7].name}
                                    idArticulo={articulosBanner[7].id}
                                    imagen={articulosBanner[7].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[8].name}
                                    idArticulo={articulosBanner[8].id}
                                    imagen={articulosBanner[8].image}
                                />
                                <ItemBanner 
                                    name={articulosBanner[9].name}
                                    idArticulo={articulosBanner[9].id}
                                    imagen={articulosBanner[9].image}
                                />
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;


/**
 * <div className="banner__articles--detail">
                    <h3>Comparte todo el estilo</h3>
                    <span>Audi en familia</span>

                    <button className="btn-general btn-tertiary-prev v-align-c" onClick={() => verArticulosSlide()}>
                        <svg className="i-rotate" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <path id="arrow_right" d="M10.735,16.028,12,17.293l6-6-6-6L10.735,6.558l3.84,3.84H6v1.789h8.576Z" transform="translate(-6 -5.293)" fill="#fff"/>
                        </svg>
                        <span>Volver</span>
                    </button>
                </div>
 */